import React, { useState, useEffect } from "react";
import { GridFilterCellProps } from "@progress/kendo-react-grid";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { emitDateChange } from "../helper/dateFilterCallbackStore";

const ContractExpirationFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const { onChange } = props;

  const [filterType, setFilterType] = useState<"all" | "last90" | "custom">(
    "all",
  );
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  useEffect(() => {
    if (filterType === "last90") {
      const fromDate = new Date(new Date().setDate(new Date().getDate() - 90));
      emitDateChange({ filterType: "last90", startDate: fromDate });

      onChange?.({
        value: fromDate,
        operator: "gte",
        syntheticEvent: {
          nativeEvent: new Event("change"),
        } as React.SyntheticEvent<any, Event>,
      });
    } else if (filterType === "custom" && startDate && endDate) {
      emitDateChange({ filterType: "custom", startDate, endDate });
    } else if (filterType === "all") {
      emitDateChange({ filterType: "all" });

      onChange?.({
        value: null,
        operator: "",
        syntheticEvent: {
          nativeEvent: new Event("change"),
        } as React.SyntheticEvent<any, Event>,
      });
    }
  }, [filterType, startDate, endDate]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <DropDownList
        data={[
          { text: "All", value: "all" },
          { text: "Last 90 Days", value: "last90" },
          { text: "Custom Range", value: "custom" },
        ]}
        textField="text"
        dataItemKey="value"
        value={{
          text:
            filterType === "last90"
              ? "Last 90 Days"
              : filterType === "custom"
                ? "Custom Range"
                : "All",
          value: filterType,
        }}
        onChange={(e) => setFilterType(e.value.value)}
      />
      {filterType === "custom" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <DatePicker
            value={startDate}
            onChange={(e) => setStartDate(e.value)}
            placeholder="Start Date"
          />
          <DatePicker
            value={endDate}
            onChange={(e) => setEndDate(e.value)}
            placeholder="End Date"
          />
        </div>
      )}
    </div>
  );
};

export default ContractExpirationFilterCell;
